import { Location } from 'vue-router'
import { FormTemplate as Data } from '@/typings/api/FormTemplate'

import { createEdit, COPY, DELETE } from '@/helpers/enums/table-actions'
import { dateFormatter } from '@/helpers/dateFormatter'
import { FORM_TEMPLATE_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Data): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit<Data>(getEditRoute),
  COPY,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: true,
    width: 80,
  },
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: (data: Data): Location => ({
      name: ROUTES.VIEW,
      params: { id: data.id.toString() },
    }),
  },
  {
    text: 'Описание',
    value: 'description',
    sortable: false,
  },
  {
    text: 'Дата изменения',
    value: 'updated_at',
    sortable: false,
    width: 130,
    field: (value: Data['updated_at']) => (
      value && dateFormatter(value)
    ),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 130,
    field: (value: Data['created_at']) => (
      value && dateFormatter(value)
    ),
  },
])
